/**
 * Language utilities - centralized re-exports from paraglide with clearer naming
 *
 * This file provides aliases for inlang/paraglide functions to maintain
 * consistency with our LanguageCode type naming convention.
 */

import type { Locale as LanguageCode } from '$paraglide/runtime';
import {
	getLocale,
	setLocale,
} from '$paraglide/runtime';

/**
 * Get the current language code
 * @returns The current language code (e.g., "en", "fr", "de")
 *
 * @example
 * const lang = getLanguageCode(); // "fr"
 */
export const getLanguageCode = getLocale;

/**
 * Set the current language code
 * @param lang - The language code to set (e.g., "en", "fr", "de")
 *
 * @example
 * setLanguageCode("fr");
 */
export const setLanguageCode = setLocale;

/**
 * Re-export the LanguageCode type for convenience
 */
export type { LanguageCode };
